<template>
  <div class="mask" />
</template>

<script>
export default {
  name: 'CustomMask'
}
</script>


<style lang="scss" scoped>
@import "~@blibli/blue-tokens/dist/blue-tokens.scss";

.mask {
  transition: opacity $blu-speed ease;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $blu-black-medium;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
